/* eslint-disable no-undef */
/* eslint-disable no-unreachable */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-expressions */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { graphqlRequest, getTranslations, getCleanObject, removeLeadingSlash, getContentSection } from "../helpers"
import { normalizeGames } from "../helpers/gamesHelper"
import { HEADER_NAVIGATION, FOOTER_NAVIGATION } from "../helpers/constants"

const {
  REACT_APP_HEADER_LINKS: headerLinks = "",
  REACT_APP_FOOTER_LINKS: footerLinks,
  // REACT_APP_LMBAS_API: apiUrl,
  REACT_APP_EXTERNAL_GAMES_API: externalGamesApi,
  REACT_APP_MARKET_UID: marketUId,
  REACT_APP_DOMAIN_ZONE: domainZone,
  REACT_APP_CODE: siteCode,
  REACT_APP_MEDIA_URL: mediaUrl,
  REACT_APP_IMAGEKIT_URL: imageKitUrl
} = process.env

const hasExternalGames = process.env.REACT_APP_EXTERNAL_GAMES === "true"

export const fetchDataFromRS = createAsyncThunk("data/fetchDataFromRS", async lang => {
  const query = `
query {
viewer{content{
    pages(operatorUid: "${siteCode}"
        language: "${domainZone}"
        marketUid: "${marketUId}",
        filter: { type: { name: ["content", "homepage", "legal", "lobby"] } }) {
      edges {
        node {
          name
          url
          type {
            name
          }
          metadata {
            key
            type
            value
          }
          layout {
            zones {
              name
              items {
                name
                type {
                  name
                }
                content
                attributes {
                  slug
                  vertical
                  url
                  images {
                    tile {
                      url
                    }
                  }
                }
                items {
                  name
                  type {
                    name
                  }
                  attributes {
                    slug
                    url
                    icon
                    title
                    vertical
                    images {
                      icon {
                        url
                      }
                      tile {
                        url
                      }
                    }
                  }
                  items {
                    name
                    attributes {
                      url
                    }
                  }
                }
                attributes {
                  heading
                  subheading
                  description
                  images {
                    icon {
                      url
                      alt
                    }
                    background {
                      url
                      alt
                    }
                    square {
                      url
                      alt
                    }
                  }
                  actions {
                    primary {
                      text
                      url
                    }
                  }
                  text
                  url
                }
              }
            }
          }
        }
      }
    }
  }
}
}
  `

  const res = await graphqlRequest(query, {})
  const pages = res?.viewer?.content?.pages?.edges

  console.log(res)

  const getData = data => {
    return data.map(({ node }) => ({
      name: node.name,
      url: node.url,
      type: node.type.name,
      metadata: node.metadata,
      zones: node.layout?.zones
        .map(zone =>
          zone.items.map(item => ({
            zone: zone.name,
            name: item.name,
            type: item.type.name,
            attributes: item.attributes,
            content: item.content,
            items: item.items // keep nested items if needed
          }))
        )
        .flat()
    }))
  }

  const cleanData = getData(pages)
  const data = getCleanObject(cleanData)

  const home = data.filter(item => item.name.toLowerCase() === "home")[0]
  const gamesPage = data.filter(item => item.name.toLowerCase() === "games")[0]
  const legalPages = data.filter(item => item.type.toLowerCase() === "legal")

  // Games categories in Redstone From dynamic Grid
  const rdGamesCategories = home.zones.filter(item => item.type === "games")

  home.zones = home.zones.reduce((sum, { name, type, attributes, content, items }) => {
    sum[name.replace(/\s+/g, "")] = {
      type,
      attributes,
      content,
      items
    }
    return sum
  }, [])

  const homePage = {}

  homePage.logo = home.zones.Logo?.attributes
  homePage.footerDisclaimer = home.zones.FooterDisclaimer?.content
  homePage.footerLogos = home.zones.FooterLogos?.items

  const { heading, subheading, description, actions, images } = home.zones.HomepageBanner.attributes

  const metaData = home?.metadata?.reduce((sum, { key, value }) => {
    sum[key] = value
    return sum
  }, [])

  homePage.metaTitle = metaData?.title
  homePage.metaDescription = metaData?.description
  homePage.robots = metaData?.robots
  homePage.canonical = metaData?.canonical

  homePage.bannerSection = [
    {
      title: heading,
      subTitle: subheading,
      text: description,
      ctaText: actions?.primary?.text,
      ctaLink: actions?.primary?.url,
      mobileImage: images.square.url,
      mobileImageAltText: images.square.alt,
      desktopImage: images.background.url,
      desktopImageAltText: images.background.alt
    }
  ]

  console.log("dataSlice call")

  // External games fetch
  const fetchExternalGames = async () => {
    if (!hasExternalGames) return []
    try {
      const res = await fetch(externalGamesApi, { cache: "no-store" })
      const str = await res.text()
      const parser = new DOMParser()
      const xml = parser.parseFromString(str, "application/xml")
      const gameNodes = Array.from(xml.getElementsByTagName("game"))
      return gameNodes.map(node => ({
        gameName: node.getElementsByTagName("title")[0].textContent,
        url: node.getElementsByTagName("leovegas-italy_link")[0].textContent,
        gameThumbnail: node.getElementsByTagName("screenshot")[0].textContent,
        slug: node
          .getElementsByTagName("title")[0]
          .textContent.trim()
          .toLowerCase()
          .replace(/[^\w\s-]/g, "")
          .replace(/\s+/g, "-")
      }))
    } catch (err) {
      console.error(err)
      return []
    }
  }

  const games = await fetchExternalGames()

  const allGamesCategories = hasExternalGames
    ? gamesPage?.zones
        ?.filter(item => item.name === "Games Categories")[0]
        .items.reduce((sum, item) => {
          const { name, items, attributes } = item
          return sum.concat({
            categoryName: name,
            icon: attributes?.images?.icon?.url,
            gamesList: items.map(game => {
              // try to find matching game from externalGames
              const match = games.find(
                g =>
                  g.slug === game.attributes?.url || // match by slug if present
                  g.gameName === game.name // fallback: match by name
              )

              return match
                ? {
                    gameName: match.gameName,
                    slug: match.slug,
                    url: match.url,
                    gameThumbnail: match.gameThumbnail
                  }
                : {
                    // fallback to raw CMS game if not found in externalGames
                    gameName: game.name,
                    slug: game.attributes?.url || game.name.toLowerCase().replace(/\s+/g, "-"),
                    url: game.attributes?.url || "",
                    gameThumbnail: ""
                  }
            }),
            slug: attributes?.title
          })
        }, [])
    : gamesPage?.zones
        ?.filter(item => item.type === "games")
        .reduce((sum, item) => {
          const { name, items, attributes = {} } = item

          sum.push({
            categoryName: name,
            gamesList: normalizeGames(items, mediaUrl, imageKitUrl),
            slug: attributes.title || name.toLowerCase().replace(/\s+/g, "-")
          })

          return sum
        }, [])

  const staticPages = legalPages.reduce(
    (sum, { name, url, zones }) =>
      sum.concat({
        pageTitle: name,
        slug: removeLeadingSlash(url),
        pageContent: zones.filter(item => item.zone === "main")[0].content
      }),
    []
  )

  // Translations & navigation

  const isEU = lang === "ca-eu" || lang === "fr-eu"
  const translationsLang = lang.includes("-") || !isEU ? lang.substring(lang.indexOf("-") + 1) : lang
  const _translationsLang = isEU ? lang.slice(0, 2) : translationsLang
  const translations = getTranslations(_translationsLang)

  const getNavigation = nav =>
    staticPages.reduce((sum, { pageTitle, includeIn, slug }) => (includeIn?.includes(nav) ? sum.concat({ pageTitle, slug }) : sum), [])

  const getExtraNavigation = links => {
    return links.split(",").map(item => ({
      pageTitle: translations.links[item],
      slug: translations.slugs[item],
      id: item
    }))
  }

  const headerNavigation = getNavigation(HEADER_NAVIGATION).concat(getExtraNavigation(headerLinks))
  const footerNavigation = getNavigation(FOOTER_NAVIGATION).concat(getExtraNavigation(footerLinks))

  homePage.cookieConsentContent = translations.cookiesPolicy

  const getGamesList = data => {
    return data?.reduce(
      (sum, { items, name }) =>
        sum.concat({
          categoryName: name,
          gamesList: normalizeGames(items, mediaUrl, imageKitUrl),
          slug: name.toLowerCase().replace(/\s+/g, "-")
        }),
      []
    )
  }

  const externalGamesHomeCategories = () => {
    return home.zones?.GamesCategories?.items.reduce((sum, item) => {
      const { name, items, attributes } = item
      return sum.concat({
        categoryName: name,
        icon: attributes?.images?.icon?.url,
        gamesList: items.map(game => {
          // try to find matching game from externalGames
          const match = games.find(
            g =>
              g.slug === game.attributes?.url || // match by slug if present
              g.gameName === game.name // fallback: match by name
          )

          return match
            ? {
                gameName: match.gameName,
                slug: match.slug,
                url: match.url,
                gameThumbnail: match.gameThumbnail
              }
            : {
                // fallback to raw CMS game if not found in externalGames
                gameName: game.name,
                slug: game.attributes?.url || game.name.toLowerCase().replace(/\s+/g, "-"),
                url: game.attributes?.url || "",
                gameThumbnail: ""
              }
        }),
        slug: attributes?.title
      })
    }, [])
  }

  homePage.gamesCategories = hasExternalGames ? externalGamesHomeCategories() : getGamesList(rdGamesCategories)

  const about = getContentSection(home.zones?.About)

  homePage.contentSection = [about]

  const { signUp } = translations

  return {
    homePage,
    games,
    allGamesCategories,
    staticPages,
    signUp,
    headerNavigation,
    footerNavigation,
    translations
  }
})

export const fetchData = lang => {
  return fetchDataFromRS(lang)
}

const initialState = {
  homePage: {},
  games: {},
  allGamesCategories: [],
  promotions: [],
  promotionsPage: {},
  pastEventsPage: [],
  staticPages: [],
  signUp: {},
  headerNavigation: [],
  footerNavigation: [],
  translations: {},
  status: "idle",
  error: null
}

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    clearData: state => {
      state.homePage = {}
      state.games = {}
      state.allGamesCategories = []
      state.promotions = []
      state.promotionsPage = {}
      state.pastEventsPage = []
      state.staticPages = []
      state.signUp = {}
      state.headerNavigation = []
      state.footerNavigation = []
      state.translations = {}
      state.status = "idle"
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDataFromRS.pending, state => {
        state.status = "loading"
      })
      .addCase(fetchDataFromRS.fulfilled, (state, action) => {
        state.status = "succeeded"
        Object.assign(state, action.payload)
      })
      .addCase(fetchDataFromRS.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
  }
})

export const { clearData } = dataSlice.actions

// ✅ Add selector
export const selectData = state => state.data

export default dataSlice.reducer
